import dayjs from 'dayjs';

export default {
  getForm: state => state.form,
  getFormatEventDateTime: state => {
    const { eventDate, eventDateTime } = state.form;

    let val = eventDateTime?.split(':') ?? [];

    if (!val) {
      return dayjs(eventDate).format('YYYY년 MM월 DD일');
    } else {
      return dayjs(eventDate).format('YYYY년 MM월 DD일') + ' ' + val[0] + '시 ' + val[1] + '분';
    }
  },
  getDetail: state => state.detail,
  getNextId: state => state.nextId,
  getList: state => state.list
};
